import React, { useEffect, useState} from 'react';
import { Bounce } from 'react-reveal';
import { Button, Dropdown, Input } from 'semantic-ui-react';
import GConf from '../AssetsM/generalConf';
import { Menu, Tab } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import TableGrid from '../AssetsM/tableaux';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import timeGridPlugin from '@fullcalendar/timegrid';
import { _ } from "gridjs-react";
import { useNavigate} from 'react-router-dom';

import AddSeanceCard from './addSeance';


const EditSeanceCard = (props) =>{
  return(<>
        <h5>Modifier cette Seance : </h5>
        <div className='mb-2 text-secondary'> <span className='bi bi-calendar'></span> Date : {props.passedData.s_date} </div>
        <div className='mb-2 text-secondary'> <span className='bi bi-clock-history'></span> Horaire : {props.passedData.s_temps} </div>
        <div className='mb-2 text-secondary'> <span className='bi bi-star-fill'></span> Matiere : {props.passedData.s_matiere} </div>
        <div className='mb-2 text-secondary'> <span className='bi bi-people'></span> Groupe : {props.passedData.s_groupe} </div>
        <div className='mb-2 text-secondary'> <span className='bi bi-houses'></span> Salle : {props.passedData.s_salle} </div>
        
        <div className='mb-3 mt-3'>
            <Button onClick={() => console.log('edited')}  style={{backgroundColor: '#9712c0', color:'white'}} className='shadow-sm w-100'> Modifier Seance    </Button>
        </div>
  </>)
}

const DeleteSeanceCard = () =>{
  return(<>
        <h5>Voulez vous vraiment supprimer cette Seance ! </h5>
        <Button className='text-white bg-danger' fluid>Oui ! Supprimer cette sea,ce</Button>
  </>)
}

function EtudiantLandingPage() {
    /*#########################[Const]###########################*/
    const today = new Date();
    const st_date = today.toISOString().split('T')[0];
    const navigate = useNavigate();
    let ProfData = JSON.parse(localStorage.getItem("ProfData"));
    let [creditValue, setCreditValue] = useState(0)
    let [seancesListe, setSeanceListe] = useState([])
    const inputIsLogged = JSON.parse(localStorage.getItem('ProfData'));
    const [activeIndex, setActiveIndex] = useState(0)
    const [sheetActiveIndex, setSheetActiveIndex] = useState('')
    const [openD, setOpenD] = useState(false)
    let [listeToShow, setListeToShow] = useState([])
    let [seanceToAddData, setSeanceToAddData] = useState({s_date: st_date ,  s_temps: null ,  s_matiere: null ,  s_groupe: null ,  s_proff: null ,  s_salle: null ,  s_etat: null})


    const panesRes = [
      {
        menuItem: { key: 'vu',  content: <span className='text-warning'><b><span className='bi bi-hourglass-split'></span> En Attent</b></span> , className:'rounded-pill'},
        render: () => <div>  <CalendarCard /> </div>,
      },
      {
        menuItem: { key: 'accept',  content: <span className='text-success'><b><span className='bi bi-check-square-fill'></span> Accepteé</b></span> , className:'rounded-pill' },
        render: () => <div> <SeanceListeCard /> </div>,
      },
      {
        menuItem: { key: 'pr',  content: <span className='text-success'><b><span className='bi bi-check-square-fill'></span> Accepteé</b></span> , className:'rounded-pill' },
        render: () => <div> <EditProfileCard /> </div>,
      },
       
    ]

    /*#########################[UseEffect]###########################*/
    useEffect(() => {
        const inputIsLogged = JSON.parse(localStorage.getItem('ProfData'));
        if (!inputIsLogged) {window.location.href = "/Admin/logIn";}
         
        axios.post(`${GConf.ApiLink}/proff/mes-seances`, {
            idp :  ProfData.idp,
        })
        .then(function (response) {
            let ms = [];
            response.data.map((data,index) => ms.push([
                  data.ids,
                  data.s_date,
                  data.s_temps,
                  data.s_matiere,
                  //data.s_groupe,
                  _(( (g) => g ? `${g.spec} - ${g.grp}` : '' )(GConf.groupeListe.find(g => g.grid == data.s_groupe))),
                  //data.s_etat,
                _(<span className={`badge bg-${data.s_etat === 'Ouvert' ? 'success': 'danger'}`}> {data.s_etat} </span>),
              _(<Button className='rounded-pill bg-primary text-white' size='mini' onClick={ (e) => OpenBottomSheetFunction('Edit')}><span className='bi bi-pen'></span> </Button>),
              _(<Button className='rounded-pill bg-danger text-white' size='mini' onClick={ (e) => OpenBottomSheetFunction('Delete')}><span className='bi bi-trash'></span> </Button>),
              _(<Button className='rounded-pill bg-secondary text-white' size='mini' onClick={ (e) => navigate(`seanceinfo/${data.ids}/${data.s_groupe}`)}><span className='bi bi-upc-scan'></span> </Button>),
            ],))
            setSeanceListe(ms)
        })
        GeneratedTime(JSON.parse(ProfData.p_emploi) !== "" ? JSON.parse(ProfData.p_emploi) : [])
    },[])

    /*#########################[Function]###########################*/
    const logOutInput = () =>{    
        localStorage.removeItem('ProfData');
        window.location.href = "/";
    }

    const OpenBottomSheetFunction = (genre) => {
        setSheetActiveIndex(genre)
        setOpenD(!openD)
    }

    const RemoveEvent = (eventId) => {
         OpenBottomSheetFunction('AddSeance')
         const eer = eventId.extendedProps.removeID
         setSeanceToAddData({s_date: st_date ,  s_temps:`${eer.de}-${eer.vers}` ,  s_matiere: eer.matiere ,  s_groupe: eer.groupe ,  s_proff: ProfData.idp ,  s_salle: eer.salle ,  s_etat: 'Ouvert'})
    }
    const GeneratedTime = (listeValue) => {
      const jourListe = [
          {id:0, value :'Dim', text:'Dimanche'},
          {id:1, value :'Lun', text:'Lundi'},
          {id:2, value :'Mar', text:'Mardie'},
          {id:3, value :'Mer', text:'Mercredie'},
          {id:4, value :'Jeu', text:'Jeudi'},
          {id:5, value :'Ven', text:'Vendredie'},
          {id:6, value :'Sam', text:'Samedie'},
          
      ]

        let curr = new Date()
        let first = curr.getDate() - curr.getDay()
        const TargertDateIs = (dayIndex) => { return new Date(curr.setDate(first + dayIndex)).toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' )}
        
        const findIdByValue = (value) => {
            const jour = jourListe.find(jour => jour.value === value);
            return jour ? jour.id : null;
        }

        const TargertColor = (matiere) => { 
            let targetMat = GConf.matiereListe.find((data) => data.nom === matiere)
            if (targetMat) {
                return targetMat.matCol
            } else{
                return '#7f7f7f'
            }
        }

        let reternedListe = []
        listeValue.map( (getData,index) => (
            getData.seances.map((data) =>  reternedListe.push({ title: `${data.matiereName} (${data.salleName})`,  start: `${TargertDateIs(findIdByValue(getData.day))}T${data.de}` , end: `${TargertDateIs(findIdByValue(getData.day))}T${data.vers}`,  className:'border-0 rounded-0 m-0 p-0', backgroundColor:  TargertColor(data.matiere), removeID: data, removeIDDay: getData.day })) 
        ))         
        setListeToShow(reternedListe)
        
    }

    /*#########################[Card]###########################*/
    const MainTopCard = () =>{
        return(<>
            <div className='card p-3 fixed-top border-0 shadow-sm  rounded-0'>
                <div className='row'>
                    <div className='col-4 align-self-center'>
                        <NavLink exact='true' to='/'>
                            <span className='bi bi-arrow-left-short bi-md text-primary'></span>
                        </NavLink>

                    </div>
                    <div className='col-8 align-self-center text-end' ><h2> <span className="badge bg-info"> <span className='bi bi-person '></span>  {ProfData.p_nom}  </span></h2></div>
                    
                </div>
            </div>
        </>)
    }

    const CustomTabs = () => {
      return(<>
        <div className='row mb-3'>
          <div className='col-12 col-lg-10 align-self-center' >
            <div style={{width:'100%', overflowX: 'auto', overflowY : 'hidden',  whiteSpace:'nowrap'}}>
              <Menu secondary >
                  <Menu.Item active={activeIndex == 0} className='rounded-pill' onClick={ () => setActiveIndex(0)}>
                    <span className='text ' style={{color: '#00b8e6'}}>
                      <b>
                        <span className='bi bi-calendar-week'></span> Mon Calendrier 
                      </b>
                    </span>
                  </Menu.Item>
                  <Menu.Item active={activeIndex == 1} className='rounded-pill' onClick={ () => setActiveIndex(1)}>
                    <span className='text' style={{color: '#e69500'}}>
                      <b>
                        <span className='bi bi-clock-history'></span> Mes Seances 
                      </b>
                    </span>
                  </Menu.Item>
                 <Menu.Item active={activeIndex == 2} className='rounded-pill' onClick={ () => setActiveIndex(2)}>
                    <span className='text' style={{color: '#4e4d4b'}}>
                      <b>
                        <span className='bi bi-person-circle'></span> Mon Profile
                      </b>
                    </span>
                  </Menu.Item> 
              </Menu>
            </div>
          </div>
          <div className='col-4 text-end'>
              {/* <Button icon='calendar alternate' className='rounded-pill bg-system-btn me-4' onClick={() => openEditModal('justOpen',true)} /> */}
              {/* <MainSubNavCard text='Calendrier' link='rq/calendrier' icon='calendar-week' /> */}
          </div>
        </div>
      </>)
    }

    const SeanceListeCard = () => {
      return(<>
        <>
          <div className='card card-body border-div shadow-sm mb-3'>
            <div className='row'>
              <div className='col-12'>
                <Button onClick={() => OpenBottomSheetFunction('Add')} style={{backgroundColor: "#0c65b9"}} className='rounded w-auto text-white'  > <span className='bi bi-plus'></span> Ajouter Seance </Button>  
              </div>
            </div>
              
             
          </div>
          <TableGrid tableData={seancesListe} columns={["id","Date","Temps", "Matiere", "Groupe", "Etat",  "Modif.", "Supp", "info"]} />
        </>
      </>)
    }

    const CalendarCard = ()=> {
      return(<>
      <div className='card card-body mb-4'>
          <FullCalendar 
                plugins={[ timeGridPlugin ]}
                initialView="timeGridWeek"
                locale='fr' 
                dayHeaderFormat = {{weekday: 'short'}}
                events={listeToShow}
                eventClick={(clickInfo) => RemoveEvent(clickInfo.event)}
                headerToolbar='false'
                height='490px'
                allDaySlot= {false}
                slotMinTime = '08:00'  
                slotMaxTime = '18:00' 
            /> 
    </div>
      </>)
    }

    const EditProfileCard = () => {
      let [proffData, setProffData] = useState(ProfData);
      console.log(ProfData)
      return(<>
        <div className='card card-body shadow border-div mb-4 col-12 col-lg-6'>
          <h3 className='text-secondary'>Modifier votre Profile </h3>
          <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Nom du Proff : </h5>
            <Input  icon='user' iconPosition='left' placeholder='Nom .. ' value={proffData.p_nom || ''} className='shadow-sm w-100' onChange={(e) => setProffData({...proffData, p_nom: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> E-mail du Proff : </h5>
            <Input  icon='mail' iconPosition='left' placeholder='Email .. ' value={proffData.p_email || ''} className='shadow-sm w-100' onChange={(e) => setProffData({...proffData, p_email: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Matiere : </h5>
            {/* <Input  icon='user' iconPosition='left' placeholder='Nom .. ' className='shadow-sm w-100' onChange={(e) => setProffData({...proffData, p_matiere: e.target.value })}/> */}
            <Dropdown
                search
                selection
                wrapSelection={false}
                options={GConf.matiereListe.map((data, index) => ({id : index, value: data.nom, text:data.nom }))}
                placeholder='Selectionnez Matiere'
                className='mb-1 shadow-sm w-100'
                onChange={(e, { value }) => setProffData({...proffData, p_matiere: value })}
                value={proffData.p_matiere || ''}
            />

            <div className='mb-3 mt-3'>
                <Button onClick={() => alert()}  style={{backgroundColor: '#0c4f8d', color:'white'}} className='shadow-sm w-100'> Modifier Votre Profile </Button>
            </div>
            <Button onClick={logOutInput} style={{backgroundColor: '#272e2b'}} className='rounded text-white' icon='log out' >Deconnextion</Button>
        </div>
      </>)
    }

    return ( <>
            <MainTopCard />
            <br />                
            <br />                
            <br />                
            <br />   
                   
            <div className='container'>
                 
                <CustomTabs  /> 
                <Tab menu={{ secondary: true }} activeIndex={activeIndex} panes={panesRes}  className='no-menu-tabs mt-2' />
                 <br />
                 <br />
            </div> 
            <BottomSheet style={{ '--rsbs-max-w': '50vw',  '--rsbs-ml': 'auto', '--rsbs-mr': 'auto' }} expandOnContentDrag open={openD}  onDismiss={() => setOpenD(!openD)}  >
                <div className='card-body'>
                    { sheetActiveIndex =='AddSeance' ?  <AddSeanceCard passedData={seanceToAddData} />  : <></> }  
                    { sheetActiveIndex == 'Edit' ?  <EditSeanceCard passedData={seanceToAddData} /> : <></> }
                    { sheetActiveIndex == 'Delete' ?  <DeleteSeanceCard /> : <></> }
                    { sheetActiveIndex == 'Other' ?  <>other </> : <></> }   
                </div>
            </BottomSheet>
        </> );
}

export default EtudiantLandingPage;